import React from 'react';
import { Button, Container } from 'semantic-ui-react';
import useDownloadFile from '@api/filesUpload/hooks/useDownloadFile';

type Props = {
  fileName: string;
  uploadId: number;
};

function DownloadableFile({ fileName, uploadId }: Props) {
  const { downloadFile } = useDownloadFile(uploadId, { enabled: false });
  return (
    <Container
      onClick={(e: Event) => {
        e.stopPropagation();
      }}
    >
      <Button basic onClick={() => downloadFile()} size="tiny">
        {fileName}
      </Button>
    </Container>
  );
}

export default DownloadableFile;
